function createExtraScopePlugin() {
  for (var _len = arguments.length, extra = new Array(_len), _key = 0; _key < _len; _key++) {
    extra[_key] = arguments[_key];
  }

  var scopes = extra.map(function (scope) {
    return scope.trim() + " ";
  });
  var seen = new WeakSet();

  var extraScopePlugin = function extraScopePlugin(context, content, selectors, parents, line, column, length, type) {
    if (context !== 2 || type === 107 || seen.has(selectors)) return;
    seen.add(selectors);

    var _loop = function _loop(i) {
      selectors[i] = scopes.map(function (scope) {
        return "" + scope + selectors[i];
      }).join(',');
    };

    for (var i = 0; i < selectors.length; i++) {
      _loop(i);
    }
  };

  return extraScopePlugin;
}

export default createExtraScopePlugin;
